import { TRADEIN_SWITCH } from '../constants';

/**
 * Get hardware only from DOM
 */
export const getIsTradeInFromDom = (): boolean => {
    const container = document.getElementById(TRADEIN_SWITCH);
    const checkbox = container?.getElementsByTagName('input')[0];

    return checkbox?.checked || false;
};

/**
 * toggle trade-in switch
 * @param checked
 */
export const setTradeInSwitch = (checked: boolean): void => {
    const container = document.getElementById(TRADEIN_SWITCH);
    const checkbox = container?.getElementsByTagName('input')[0];

    if (checkbox) {
        checkbox.checked = checked;
    }
};

/**
 * disable trade-in switch, or enable
 * @param disabled Boolean to enable or disable the checkbox
 * @TODO The name of the function is confusing because
 * the function is also used to enable the switch by passing `true`.
 * Maybe the name `setTradeInSwitchDisabled` would be better.
 */
export const disableTradeInSwitch = (disabled: boolean): void => {
    const container = document.getElementById(TRADEIN_SWITCH);
    const checkbox = container?.getElementsByTagName('input')[0];

    if (checkbox) {
        checkbox.disabled = disabled;
    }
};

/**
 * check if trade-in switch is on
 *
 */
export const isTradeInSwitchOn = (): boolean => {
    const container = document.getElementById(TRADEIN_SWITCH);
    const checkbox = container?.getElementsByTagName('input')[0];

    return checkbox?.checked || false;
};
